import styled from '@emotion/styled';
import React from 'react';
import { mqMin } from 'utils/responsive';

const DescriptionText = styled.p`
    font-family: 'Zen Kaku Gothic Antique', -apple-system, Roboto, Helvetica, sans-serif;
    font-size: 0.96rem;
    line-height: 160%;
    letter-spacing: 0.8px;
    color: #1e4e66;
    margin: 0;
`;

const HighlightText = styled.span`
    font-weight: 700;
    color: #ee793f;
    background-color: #fffbc9;
`;

const SuccessionTypesContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 24px;
    margin: 40px auto 0 auto;
    flex-direction: column;

    ${mqMin('SP')} {
        gap: 44px;
        flex-direction: row;
        align-items: flex-start;
    }
`;

const SuccessionTypeItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
`;

const CircleWrapper = styled.div`
    position: relative;
    width: 118px;
    height: 119px;
    flex-shrink: 0;
`;

const CircleOutlined = styled.div`
    width: 118px;
    height: 119px;
    border-radius: 50%;
    border: 3px solid #1695d4;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const CircleFilled = styled.div`
    width: 118px;
    height: 119px;
    border-radius: 50%;
    background: #1695d4;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const CircleLabel = styled.div`
    font-family: 'Zen Kaku Gothic Antique', -apple-system, Roboto, Helvetica, sans-serif;
    font-size: 16px;
    font-weight: 700;
    line-height: 160%;
    letter-spacing: 0.8px;
    color: #1695d4;
    text-align: center;
`;

const CircleLabelWhite = styled(CircleLabel)`
    color: #fff;
`;

const DescriptionLabel = styled.div`
    font-family: 'Zen Kaku Gothic Antique', -apple-system, Roboto, Helvetica, sans-serif;
    font-size: 14px;
    line-height: 160%;
    letter-spacing: 0.7px;
    color: #1e4e66;
    text-align: center;
    white-space: pre-line;
`;

const DescriptionLabelBold = styled(DescriptionLabel)`
    font-weight: 700;
`;

export const MaForBeginnerDerail_2_1: React.FC = () => {
    return (
        <>
            <DescriptionText>
                仲介会社は、M&Aを成立させるために売り手と買い手の間に立ち、交渉や調整を行う専門機関です。
                直接取引に比べ、 <HighlightText>情報開示や契約交渉の過程で専門的な知識を提供してくれる</HighlightText>
                点が大きな違いです。また、FA（ファイナンシャルアドバイザー）は、依頼者の利益を一方的に代表して動くのに対し、仲介会社は双方の合意形成を支援する立場を取ります。そのため、{' '}
                <HighlightText>
                    トラブルの回避やスムーズな合意形成を望む場合には仲介会社を利用するメリットが大きい
                </HighlightText>
                といえます。
            </DescriptionText>
            <SuccessionTypesContainer>
                <SuccessionTypeItem>
                    <CircleWrapper>
                        <CircleOutlined>
                            <CircleLabel>直接取引</CircleLabel>
                        </CircleOutlined>
                    </CircleWrapper>
                    <DescriptionLabel>{'手数料がかからないが\nトラブル発生しやすい'}</DescriptionLabel>
                </SuccessionTypeItem>
                <SuccessionTypeItem>
                    <CircleWrapper>
                        <CircleOutlined>
                            <CircleLabel>FA</CircleLabel>
                        </CircleOutlined>
                    </CircleWrapper>
                    <DescriptionLabel>{'依頼者の利益を\n一方的に代表して動く'}</DescriptionLabel>
                </SuccessionTypeItem>
                <SuccessionTypeItem>
                    <CircleWrapper>
                        <CircleFilled>
                            <CircleLabelWhite>{'仲介会社'}</CircleLabelWhite>
                        </CircleFilled>
                    </CircleWrapper>
                    <DescriptionLabelBold>{'情報開示や契約交渉の過程で\n専門的な知識を提供'}</DescriptionLabelBold>
                </SuccessionTypeItem>
            </SuccessionTypesContainer>
        </>
    );
};
